module.exports = __webpack_public_path__ + "static/img/banner2.02a2039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.png
// module id = pMVX
// module chunks = 1